import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const getDashboardCardCount = (project) => AxiosClient.get(`/dashboard/project/${project}`, project);
const getDashboardTicketsCount = (project) => AxiosClient.get(`/dashboard/project/status/${project}`, project);
const getDashboardAllData = (query) => AxiosClient.get('/fetch/project-dashboard', { ...query });
const shareVisitorLink = () => AxiosClient.post('/visitor-token-generate')
const getGenderWisePMCount = () => AxiosClient.get('/dashboard/gender-wise-pm')

export {
    getDashboardCardCount,
    getDashboardTicketsCount,
    getDashboardAllData,
    shareVisitorLink,
    getGenderWisePMCount
}